import { ValidatorProvider } from '@dofleini/validator';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

import { Tooltip } from '@/components/Tooltip';
import { CACHE_KEY_LIST_BANK_OFFICE } from '@/modules/configuration/contants/bankOffice';
import BankOfficeApiService from '@/modules/configuration/services/BankOfficeApiService';
import SelectElementCmp from '@/utils/SelectElementCmp';

const BankOfficeSelect = ({ value, onChange, filters, ...props }) => {
  const currentValue = value ? (typeof value === 'object' ? value._id : value) : null;
  
  const onRenderItem = useCallback(({ name, address }) => {
    return <div className="truncate">
      <div className="flex items-center truncate">
        <div className="font-semibold">{name}</div>
      </div>
      <Tooltip title={address?.abstract || name} placement="left" className="truncate">
        <div className="text-xs truncate">{address?.abstract}</div>
      </Tooltip>
    </div>;
  }, []);
  
  return (
    <>
      <div className={'w-full truncate'}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_BANK_OFFICE}
          filters={filters}
          service={BankOfficeApiService}
          includeValue={value}
          value={currentValue}
          onChange={onChange}
          customItemRender={onRenderItem}
          sort={{ code: 1 }}
          customMapItem={(v) => ({ ...v, name: `(${v.code}) ${v.name}` })}
          queryConfig={{ refetchOnWindowFocus: false }}
        />
      </div>
    </>
  );
};

BankOfficeSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  filters: PropTypes.object
};

export default memo(BankOfficeSelect);

export const renderBankOfficeSelect = ({ formItemProps, field, form }) => {
  
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <BankOfficeSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
